export default function formatEthPrice(price: string | number): number {
  return +(Math.ceil(+price * 10000) * 0.0001).toFixed(4);
}
